import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import json from './translations.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      es: {
        translation: json.es
      },
      en: {
        translation: json.en
      }
    },
    lng: 'es', // if you're using a language detector, do not define the lng option
    fallbackLng: 'es',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      formatSeparator: ','
    },
    debug: false,
    keySeparator: false, // we use content as keys
    nsSeparator: false,
    returnNull: false
  });

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language || 'es';
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
